import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from '../src/Pages/Login/index.tsx';
import HomePage from '../src/Pages/Home/index.tsx';
import Report from '../src/Pages/Report/index.tsx';
import { AuthProvider } from '../src/Context/UserContext/index.tsx';
import MainLayout from './Component/Layout/index.tsx';
import VideoPage from "../src/Pages/Video/index.tsx";
import Atten from "../src/Pages/Attendance/index.tsx";
import Questions from "../src/Pages/Questions/index.tsx";
import Summary from './Pages/Summary/index.tsx';
import CourseInfo from './Pages/CourseInfo/index.tsx';
import Cert from './Pages/Cert/index.tsx';
import AddCourse from './Pages/AddCourse/index.tsx';
import AddCourseNew from './Pages/AddCourseNew/index.tsx';
import AddStudent from './Pages/AddStudent/index.tsx';
import Admin from './Pages/Admin/index.tsx';
import AddQuestion from './Pages/AddQues/index.tsx';
import HomeAd from './Pages/HomeAd/index.tsx';
import SummaryAdmin from './Pages/SummaryAdmin/index.tsx';
import ViewCandidate from './Pages/ViewCandidate/index.tsx';
import ViewClass from './Pages/ViewClass/index.tsx';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Route for login page (no sidebar) */}
          <Route path="/" element={<LoginPage />} />

          {/* Routes with sidebar, wrapped in MainLayout */}
          <Route element={<MainLayout />}>
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin-home" element={<HomeAd />} />

            <Route path="/attendance" element={<Atten />} />
            <Route path="/report" element={<Report />} />
            <Route path="/mcq-summary" element={<Summary />} />
            <Route path="/video/:id" element={<VideoPage />} />
            <Route path="/course-info" element={<CourseInfo />} />

            <Route path="/mcq/:id" element={<Questions />} />
            <Route path="/cert-download" element={<Cert />} />
            <Route path="/add-course" element={<AddCourse />} />
            <Route path="/add-course-new" element={<AddCourseNew />} />
            <Route path="/add-student" element={<AddStudent/>} />
            <Route path="/add-question" element={<AddQuestion/>} />
            <Route path="/summary-admin" element={<SummaryAdmin/>} />
            <Route path="/all-candidate" element={<ViewCandidate/>} />
            <Route path="/all-class" element={<ViewClass/>} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
